import { z } from 'zod/v4';

export const CreatePlanPersonSchema = z.object({
  userId: z.string().min(1, 'User ID is required'),
  companyId: z.string().min(1, 'Company ID is required'),
});

export const CreatePlanRequestSchema = z.object({
  title: z.string().min(1, 'Title is required').max(4000, 'Title too long'),
  companyId: z.string().min(1, 'Company ID is required'),
  sourceType: z.string().min(1, 'Source type is required'),
  sourceId: z.string().min(1, 'Source ID is required'),
  assignees: z.array(CreatePlanPersonSchema).optional(),
  reporters: z.array(CreatePlanPersonSchema).optional(),
  dueDate: z.string().nullable(),
  tags: z.array(z.string()).nullable(),
});
export type CreatePlanRequest = z.infer<typeof CreatePlanRequestSchema>;
